import axios from 'axios'

const reply = {}
// 删除留言
reply.del = params => { return axios.get('/video/live/msg/del', {params}) }
// 加载单个留言
reply.load = params => { return axios.get('/video/live/msg/load', {params}) }
// 回复留言
reply.replyMsg = params => { return axios.post('/video/live/msg/reply', params) }
// 保存留言
reply.save = params => { return axios.post('/video/live/msg/save', params) }
// 查询留言
reply.find = params => { return axios.get('/video/live/msg/find', {params}) }
// 查看留言
reply.msgLook = params => { return axios.get('/video/live/msg/look', {params}) }
export default reply



// WEBPACK FOOTER //
// ./src/api/reply.js